export const bgMainHeader = require('./bg-services.png?webp');
export const truckImg1 = require('./truck1.png?webp');
export const truckImg2 = require('./truck2.png?webp');
export const truckImg3 = require('./truck3.png?webp');
export const truckImg4 = require('./truck4.png?webp');
export const truckImg5 = require('./truck5.png?webp');
export const truckImg6 = require('./truck6.png?webp');
export const truckImg7 = require('./truck7.png?webp');
export const truckImg8 = require('./truck8.png?webp');
export const truckImg9 = require('./truck9.png?webp');
export const truckImg10 = require('./truck10.png?webp');
